import { PageInfo } from './page-info';
var Page = /** @class */ (function () {
    function Page(pageName, language) {
        this.pageInfo = new PageInfo(pageName, language);
    }
    Page.prototype.getPageInfo = function () {
        return this.pageInfo;
    };
    return Page;
}());
export { Page };
